import { QueryEntity } from '@datorama/akita';
import { EmployeeState, employeeStore } from './employee.store';
import { switchMap } from 'rxjs/operators';
import { Maintenance, sortByName, Housekeeping } from '@lib/state';

export class EmployeeQuery extends QueryEntity<EmployeeState> {
  employees = this.select(({ ui }) => ui.filters).pipe(
    switchMap(filters =>
      this.selectAll({
        filterBy: [
          x =>
            !filters.propertyId || x.propertyRoles.some(r => r.propertyId === filters.propertyId),
          x =>
            !filters.roles ||
            !filters.roles.length ||
            !filters.propertyId ||
            filters.roles.every(r =>
              x.propertyRoles.some(pr => pr.role === r && pr.propertyId === filters.propertyId)
            ),
          x =>
            !filters.firstName ||
            (x.name.first?.toLowerCase().includes(filters.firstName.toLowerCase()) ?? false),
          x =>
            !filters.lastName ||
            (x.name.last?.toLowerCase().includes(filters.lastName.toLowerCase()) ?? false),
        ],
        sortBy: (a, b) => sortByName(a.name, b.name),
      })
    )
  );

  maintenanceEligibleEmployees = this.selectAll({
    filterBy: [x => x.propertyRoles.some(r => r.role === Housekeeping || r.role === Maintenance)],
    sortBy: (a, b) => sortByName(a.name, b.name),
  });

  selectedEmployee = this.selectActive();

  inviteExists = this.select(({ ui }) => ui.inviteExists);

  loading = this.selectLoading();
}

export const employeeQuery = new EmployeeQuery(employeeStore);
